export default __webpack_public_path__ + "476c9b4e143039cf1718d46048830916.png";